Modernizr.on('webp', function (result) {
    if (result) {
        $('html').addClass('webp');
    } else {
        $('html').addClass('no-webp');
    }
});